import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-blog-standard',
  templateUrl: './blog-standard.component.html',
  styleUrl: './blog-standard.component.css'
})
export class BlogStandardComponent {
  // Main Blog Posts
  posts = [
    {
      title: 'Kobe Steel plant that supplied plane components being checked',
      category: 'News',
      categoryClass: 'purple-color',
      time: '7 hours ago',
      image: 'assets/images/blogs/post-01.jpg',
    }
  ];

  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  // Nested Comments Data
  comments = [
    {
      author: 'John Smith',
      avatar: 'assets/images/team/avatar-2.jpg',
      time: 'Just Now',
      message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      replies: [
        {
          author: 'Amy Smith',
          avatar: 'assets/images/team/avatar-1.jpg',
          time: '59 mins ago',
          message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
        }
      ]
    }
  ];

  // Sidebar Data
  archives = [
    { month: 'January', count: 54 },
    { month: 'December', count: 83 },
    { month: 'April', count: 96 }
  ];

  categories = ['Graphic Design', 'Web Design', 'Web Development', '3D Animation'];
  tags = ['Creative Ideas', 'MonsterOne', 'PSD', 'Design', 'Planning'];

  //Footer
  socialLinks = [
    { icon: 'bi-facebook', url: '/' },
    { icon: 'bi-twitter-x', url: '/' },
    { icon: 'bi-pinterest', url: '/' },
    { icon: 'bi-dribbble', url: '/' }
  ];

  quickLinks = [
    { name: 'About Us', url: '/about-us' },
    { name: 'Services', url: '/services' },
    { name: 'Portfolio', url: '/portfolio-one' },
    { name: 'Blogs', url: '/blog-grid' },
    { name: 'Contact Us', url: '/contact' }
  ];

  recentPosts = [
    {
      image: 'assets/images/blogs/post-img-sm.jpg',
      title: 'Ut venenatis, Commodo ligula',
      desc: 'Lorem ipsum dolor sit amet, adipiscing elit...'
    },
    {
      image: 'assets/images/blogs/post-img-sm-2.jpg',
      title: 'Ut venenatis, Commodo ligula',
      desc: 'Lorem ipsum dolor sit amet, adipiscing elit...'
    }
  ];
}
